var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showOverlay)?_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin"}}):_vm._e(),(_vm.alarm)?_c('span',{staticClass:"alarmLetzerBesuchsbericht"},[_c('alarm-level-icon',{attrs:{"alarm":_vm.alarm}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }